<app-page-heading [title]="formTitle" [subheadingIcon]="'fa fa-user-plus'"></app-page-heading>

<app-user-form #userForm [user]="user" [mode]="mode" [userTypeLabelKey]="'user-dashboard.groups.administrator'"
               [create]="onCreate" [update]="onUpdate"
               [remove]="onDelete" [block]="onToggleBlocking"
               [unblockIp]="onUnblockIp"
               (changePassword)="changePassword($event)"
               (afterCreate)="goToAdminList()"
               (afterDelete)="goToAdminList()"
>
</app-user-form>
